<!-- 批量提醒弹窗 -->
<template>
    <el-dialog title="查看详情" :visible.sync="isShow" top="100px" width="30%" custom-class="custom-dialog-class"
        @close="closeBatchPass">
        <div class="dialog-container" style="text-align: center;">
            <div>您已勾选{{ count }}条待审记录，执行通过后，内容将立即发布至患者端小程序</div>
            <div>请注意当前操作会覆盖现有版本且无法撤回！</div>
        </div>
        <template #footer>
            <div style="text-align: center;">
                <el-button type="primary" @click="submit">确 认</el-button>
                <el-button @click="closeBatchPass(false)">取 消</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
export default {
    name: 'BatchPassDialog',
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeBatchPass: {
            type: Function,
            default: () => { }
        },
        count: {
            type: Number,
            default: 0
        },
    },
    computed: {
        isShow: {
            get() {
                return this.isOpen;
            },
            set(val) {
                this.closeDialog(val);
            }
        }
    },
    methods: {
        submit() {
            this.$emit('batchPass');
            this.closeBatchPass(false);
        }
    }
}
</script>
<style lang="scss" scoped>
.itemContainer {
    display: flex;
    gap: 10px;

    .item {
        background-color: rgb(203, 226, 255);
        color: rgba(26, 124, 242);
        border-radius: 50px;
        padding: 0 8px;
        min-width: 60px;
        text-align: center;
    }
}
</style>